import { useEffect } from 'react'

import { getScrollTo } from '../../utils/LayoutUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'


const decorators = [
  memoized,
]

function BodyScrollToTop() {
  useEffect(() => {
    const scrollToFn = getScrollTo()

    scrollToFn(0, 0)
  })

  return null
}

BodyScrollToTop = chainDecorators(decorators, BodyScrollToTop)

export default BodyScrollToTop
